import { styled } from '@mui/material/styles';
import * as React from 'react';
import { Typography } from '@mui/material';
import { formatMoney } from '@lialo/common/lib/formatter/money';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

const PREFIX = 'PriceDisplay';

const classes = {
  container: `${PREFIX}-container`,
  row: `${PREFIX}-row`,
  fees: `${PREFIX}-fees`,
  price: `${PREFIX}-price`,
  reduced: `${PREFIX}-reduced`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.container}`]: {
    padding: theme.spacing(1, 1),
  },
  [`& .${classes.row}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  [`& .${classes.fees}`]: {
    position: 'relative',
    top: theme.spacing(-0.5),
  },
  [`& .${classes.reduced}`]: {
    color: theme.palette.error.main,
    marginRight: theme.spacing(1),
    textDecoration: 'line-through',
  },
  [`& .${classes.price}`]: {
    fontSize: '1rem',
  },
}));

interface Props {
  price: string;
  reducedPrice?: string | null;
  className?: string;
}

export const PriceDisplay = ({ price, reducedPrice, className }: Props) => {
  const { t } = useTranslation();

  return (
    <Root className={classNames(classes.container, className)}>
      <div className={classes.row}>
        <Typography
          className={classNames(classes.price, { [classes.reduced]: !!reducedPrice })}
          component={'div'}
          variant={'subtitle2'}
        >
          {formatMoney(price)}
        </Typography>
        {reducedPrice && (
          <Typography className={classes.price} component={'div'} variant={'subtitle2'}>
            {formatMoney(reducedPrice)}
          </Typography>
        )}
      </div>
      <Typography className={classes.fees} variant={'caption'}>
        {t('checkout.product_price.including_fees')}
      </Typography>
    </Root>
  );
};
